import {h} from 'preact';

export default function AddAssociatedUsersSuccess({usersNum}) {
	const message = (usersNum > 1) ? 'invitations were' : 'invitation was';
	return (
		<div className="eds-c-status-message eds-c-status-message--success">
			<div className="eds-c-status-message__content-icon">
				<svg  aria-hidden="true" width="16" height="13px"
					 className="eds-c-status-message__icon">
					<use href="/static/img/svg-sprite.svg#success"/>
				</svg>
			</div>
				<div className="eds-c-status-message__text">
					<span>{usersNum} {message} sent.</span>
				</div>
		</div>
	)
		;
}
